type SiteHost = 'EDITOR' | 'STUDIO' | 'EDITOR3' | 'STUDIO2';

type GlobalWithCommonConfig = typeof globalThis & {
  commonConfig?: {
    host?: SiteHost;
  };
};

function getGlobalObject(): GlobalWithCommonConfig | undefined {
  if (typeof globalThis === 'object') {
    return globalThis;
  } else if (typeof self === 'object') {
    return self;
  } else if (typeof global === 'object') {
    return global;
  }
}

function getSiteHost(): SiteHost {
  const globalObj = getGlobalObject();
  return globalObj?.commonConfig?.host ?? 'EDITOR';
}

export function isBuilderEditor(): boolean {
  const host = getSiteHost();
  return host === 'EDITOR3' || host === 'STUDIO2';
}

export function isStudio2(): boolean {
  const host = getSiteHost();
  return host === 'STUDIO2';
}
